module.exports = __webpack_public_path__ + "img/link-expired.13218b57.svg";